import {
  Navigate,
  Routes as ReactRouterRoutes,
  Route,
  BrowserRouter as Router,
} from 'react-router-dom'

import { AbsoluteRoutes, Routes } from '~app/interfaces/routes'
import App from '../components/App/App'
import DesignContainer from '../components/GlobalContainer/DesignContainer'
import { ThemeModeProvider } from '../components/GlobalContainer/ThemeModeProvider'
import CustomerDetails from './customers/CustomerDetailsRoute'
import CustomerEmailUpdate from './customers/Route'
import FaultyDocuments from './documents/faulty/Route'
import ReAssignDocument from './documents/Route'
import Home from './home/Route'
import Returns from './returns/Route'
import Sources from './sources/Route'

const AppRoutes = () => {
  return (
    <ThemeModeProvider>
      <DesignContainer>
        <Router>
          <ReactRouterRoutes>
            <Route
              path="/"
              element={<Navigate to={AbsoluteRoutes.home} replace />}
            />
            <Route path="/app" element={<App />}>
              <Route index element={<Home />} />
              <Route path={Routes.returns} element={<Returns />} />
              <Route path={Routes.sources} element={<Sources />} />
              <Route
                path={Routes.filesWithErrors}
                element={<FaultyDocuments />}
              />
              <Route
                path={Routes.emailUpdate}
                element={<CustomerEmailUpdate />}
              />
              <Route path={Routes.document} element={<ReAssignDocument />} />
              <Route
                path={Routes.customerDetails}
                element={<CustomerDetails />}
              />
            </Route>
          </ReactRouterRoutes>
        </Router>
      </DesignContainer>
    </ThemeModeProvider>
  )
}

export default AppRoutes
